module.exports = "pegasus/assets/theme2/google-icon-1.png";